import { render } from "./Scene.vue?vue&type=template&id=b5945526"
import script from "./Scene.vue?vue&type=script&lang=js"
export * from "./Scene.vue?vue&type=script&lang=js"

import exportComponent from "/home/psinclair/git/hitting-the-target-australia/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__